// Prix affichés aux visiteurs, dans la convention de la langue active.
//
// « 18.99€ » — point décimal, pas d'espace — est la signature d'une boutique
// étrangère ; en français on écrit « 18,99 € », en néerlandais de Belgique
// « € 18,99 ». Intl connaît ces règles, on lui donne la locale par langue.
const LOCALES = {
  fr: 'fr-BE',
  nl: 'nl-BE',
  de: 'de-DE',
  en: 'en-IE',
  es: 'es-ES',
  lb: 'de-LU',
};

export function formaterPrix(valeur, lang) {
  const n = Number(valeur);
  if (!Number.isFinite(n)) return '';
  try {
    return new Intl.NumberFormat(LOCALES[lang] || LOCALES.fr, {
      style: 'currency',
      currency: 'EUR',
    }).format(n);
  } catch {
    return `${n.toFixed(2).replace('.', ',')} €`;
  }
}
